import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useAllCharges from "../../hooks/AllCharge";
// import { SETCARTDATA } from "../../redux/features/CartData";
// import { SETCUSTOMIZEDDATA } from "../../redux/features/CustomizedData";
// import { SETVARIATIONDATA } from "../../redux/features/Variation";
// import checkItemType from "../../utils/checkItemType";
// import DecrementItemData from "../../utils/DecrementItemData";
// import duplicateItemData from "../../utils/DuplicateItemData";
// import incrementItemData from "../../utils/Increment";
import ItemSizeName, { ItemSizeVariationName } from "../../utils/ItemSizeName";
import ParseFloat from "../../utils/ParseFloat";
// import LoaderButton from "../Buttons/LoaderButton";
import CustomizedModal from "../Modal/Customized-Modal";
import PaymentModal from "../Modal/PaymentModal";
import VariationModal from "../Modal/Variation-Modal";
import { Link } from "react-router-dom";
import Payment from "./Payment";
import Konsole from "../../utils/konsole/Konsole";
import {
  getSumOfAddOn,
  getSumOfOptions,
  getSumOfSelectedCategory,
  isTaxInclusive,
  ReturnItemCorrectPrice,
} from "../../utils/helper";
import { CheckIsMeal } from "../../utils/CustomizedCalculation/MealPrice";
import TooltipCom from "../Tootlip/TooltipCom";
import { ReturnPriceAndFree } from "../../utils/orderUtils/OrderUtils";
import NewPayment from "../Stripe-Payment/New-Payment/NewPayment";
import i18next from "i18next";
import { getItemNames } from "../../utils/GetItemsName";
import NewPaymentWithRazorpay from "../Stripe-Payment/New-Payment/NewPaymentWithRazorpay";
import { payment_type_card, tax_inclusive_type } from "../../constant/constant";
import CouponCode from "../Discount/CouponCode";
import useStoreStatus from "../../hooks/useStoreStatus";
import useReduxData from "../../hooks/useReduxData";
import useSelectedStore from "../../hooks/useSelectedStore";
const CheckoutDetails = () => {
  const { t } = useTranslation();
  const { platformFee } = useSelectedStore()
  const [
    taxes,
    discount,
    service_charge,
    remaining_amount,
    totalPrice,
    all_charge_total,
    all_charge_delivery,
    card_fees,
    round_off,
  ] = useAllCharges();
  const reduxStoreData = useReduxData();
  const { marketData } = useStoreStatus()
  const { paymentOptionType } = reduxStoreData.commonData;
  Konsole.log("taxestaxes", taxes);
  const {
    store: { selectedStore },
    variationData,
    customizedData,
    cartData: {
      items,
      itemCount,
      deliveryCharge,
      minOrderDeliveryPrice,
      discountCouponTotal,
    },
    promotions: selectedPromotionTotalDiscount,
  }: any = useReduxData();
  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);


  const onCloseModal = () => setOpen(false);
  const onClosePaymentModal = () => setOpenPayment(false);
  const [lang, setLang] = useState(i18next?.language);
  const { translations } = useSelector((state: any) => state?.languageData);

  const returnOptionsMap = (item: any, type: any) => {
    return (
      <div className="">
        {/* @@ Options Map Salad  */}

        {item?.selectedoptions?.length > 0 ? (
          <div className="text-base font-medium">
            {/* <p className=" ">Salad</p> */}
            {item?.selectedoptions?.map((step: any, index: any) => {
              return (
                <div className="flex justify-between " key={index}>
                  <p
                    key={index}
                    className="text-[#8E8E8E] capitalize font-normal"
                  >
                   +{step?.title}
                    {ReturnPriceAndFree(step?.web_price)}
                  </p>
                </div>
              );
            })}
          </div>
        ) : null}

        {/* @@ Category Map Salad  */}
        {item?.selectedCategory?.length > 0 ? (
          <div className="text-base font-medium">
            {/* <p className=" ">Salad</p> */}
            {item?.selectedCategory?.map((step: any, index: any) => {
              return (
                <div className="flex justify-between " key={index}>
                  <p
                    key={index}
                    className="text-[#8E8E8E] capitalize font-normal"
                  >
                   + {step?.mapNewItem?.name}
                    <>{ReturnPriceAndFree(step?.mapNewItem?.web_price)}</>
                  </p>
                </div>
              );
            })}
          </div>
        ) : null}

        {/* @@ add ons item display */}
        {item?.selected_addOn?.length > 0 &&
          item?.selected_addOn?.map((addOnItem: any, index: number) => {
            let price = addOnItem?.web_offered_price
              ? addOnItem?.web_offered_price
              : addOnItem?.offered_price
                ? addOnItem?.offered_price
                : 0;
            return (
              <div key={index} className="flex justify-between">
                <p className="text-[#8E8E8E] capitalize font-normal">
                  +  {addOnItem?.addon_item?.name}{" "}
                  <>{ReturnPriceAndFree(addOnItem?.web_offered_price)}</>
                </p>
              </div>
            );
          })}
      </div>
    );
  };

  // @@ Return Meal Item
  const returnMealItem = (meal: any) => {
    return meal?.map((mealItem: any, mealIndex: number) => {
      let selectedMeal = mealItem?.selectedMealItem?.[0];
      if (selectedMeal) {
        let itemDetail = selectedMeal?.item_data?.[0];
        return (
          <>
            <p className="text-md text-[#1f1c1c] mt-1 ">
              {itemDetail?.name} {ItemSizeVariationName(selectedMeal)}{" "}
              {selectedMeal?.offered_price
                ? `(${ParseFloat(selectedMeal?.offered_price)})`
                : null}
            </p>
            {returnOptionsMap(selectedMeal, "meal")}
          </>
        );
      }
    });
  };

  Konsole.log("itemCount", items, itemCount);
  return (
    <>
      <div className="store-card checkout">
        {/* @@ pre order btn */}
        {marketData?.pre ? (
          <div className="mb-2 w-auto text-center bg-[#34558B] text-white px-4 py-1 rounded-full text-sm font-medium hidden md:block">
            {t("MyOrders.preOrder")}
          </div>
        ) : null}
        {/* @@START Cart summary lock */}

        <div className="flex justify-between items-center mb-5">
          <p className="font-splekta font-normal text-xl">
            {" "}
            {t("CartDetails.cartSummary")}
          </p>
          <p className="text-base font-bold">
            {" "}
            {itemCount || 1}{" "}
            {itemCount > 1 ? t("CartDetails.items") : t("CartDetails.item")}
          </p>
        </div>
        {/* @@END Cart summary lock */}
        <div className="">
          {items?.map((item: any, index: number, itemArr: any) => {
            let item_Price = 0;

            if (CheckIsMeal(item?.is_meal)) {
              item_Price = item?.sub_total;
            } else {
              let selectedOptions = item?.selectedoptions || [];
              let selectedCategory = item?.selectedCategory || [];
              let selectedAddsOn = item?.selected_addOn || [];
              let sumOfAddOns = getSumOfAddOn(selectedAddsOn);
              let sumOfOptions = getSumOfOptions(selectedOptions);
              let sumOfCategory = getSumOfSelectedCategory(selectedCategory);
              item_Price =
                Number(item?.price) +
                (Number(sumOfOptions || 0)) +
                Number(sumOfCategory || 0) +
                Number(sumOfAddOns || 0);
            }

            item_Price = ReturnItemCorrectPrice(
              item_Price * (item?.quantity || 1),
              item?.tax_rate_list
            );
            return (
              <>
                <div className="repeatItem mt-2" key={index}>
                  {/* @@ item details */}
                  <div className="flex justify-between  text-base font-medium mb-2">
                    <p className="flex items-center gap-2">
                      <span className="border bg-[#E8E8E8] w-5 h-5 rounded text-xs inline-flex items-center justify-center">
                        {item?.quantity || 1}
                      </span>
                      {item?.name} {ItemSizeName(item)}
                    </p>

                    <p className="text-base font-bold">
                      {/* {ParseFloat(item_Price * (item?.quantity || 1))} */}

                      {ParseFloat(item_Price)}
                    </p>
                  </div>
                  {/* @@ Variations Details */}
                  {/* {ItemSizeName(item) ? (
                    <div className="text-base font-medium mb-2">
                      <p className=" ">Choose Variation<span className="text-[#8E8E8E] font-normal">
                        {ItemSizeName(item)}
                      </span> </p>
                      
                    </div>
                  ) : null} */}

                  {CheckIsMeal(item?.is_meal) && item?.meal?.length > 0
                    ? returnMealItem(item?.meal)
                    : returnOptionsMap(item, "customize")}

                  {/* @@ saved notes Display */}
                  {item.notes ? (
                    <div className="mt-3 flex gap-1 textSm">
                      <span>{t("MyOrders.notes")}: </span>
                      {item.notes || ""}{" "}
                    </div>
                  ) : null}
                </div>

                {/* @@ add more items block */}
                {itemArr.length - 1 == index ? (
                  <div className="flex justify-center gap-2 text-base font-bold cursor-pointer items-center py-4">
                    <Link to="/menu">
                      <i className="fa fa-plus"></i>{" "}
                      {t("CartDetails.addMoreItems")}
                    </Link>
                  </div>
                ) : null}

                {/* @@ for mobile screen add a line bottom */}
                <div className="block md:hidden">
                  <hr />
                </div>

                {/* @@ Horizontol line  */}
                {itemArr.length - 1 == index ? null : <hr />}
              </>
            );
          })}
        </div>
      </div>

      <div className="store-card">
        <p className="font-splekta font-normal text-xl mb-3">
          {t("CartDetails.orderTotal")}
        </p>
        <div className="flex justify-between text-lg mb-2 font-normal">
          <p>{t("CartDetails.subTotals")}</p>
          <p>{ParseFloat(taxes?.sub_total)}</p>
        </div>
        {taxes?.tax?.map((_: any, index: any) => {
          let text_name =
            _?.tax_name == "VAT" && _?.tax_type == "percentage"
              ? `${_?.tax_name}-${_?.tax_amount}% `
              : `${_?.tax_name}`;
          return (
            <div
              key={index}
              className="flex justify-between text-lg font-normal text-[#676767]"
            >
              <p>{text_name}</p>
              <p>{ParseFloat(_?.actual_tax_amount)}</p>
            </div>
          );
        })}
        {discount ? (
          <div className="flex justify-between text-lg  text-green-500 font-normal">
            <p> {t("MyOrders.discount")} </p>
            <p> {ParseFloat(discount)} </p>
          </div>
        ) : null}
        {service_charge || card_fees ? (
          <div className="flex justify-between text-lg  font-normal text-[#676767]">
            <p>{t("Checkout.serviceFee")}</p>
            <p>{ParseFloat((service_charge || 0) + (card_fees || 0))}</p>
          </div>
        ) : null}

        {deliveryCharge ? (
          <div className="flex justify-between text-lg  font-normal text-[#676767]">
            <p>{t("Checkout.deliveryFee")}</p>
            <p>{ParseFloat(deliveryCharge)}</p>
          </div>
        ) : null}
        {/* {remaining_amount ? (
          <div className="flex justify-between text-lg font-normal text-[#676767]">
            <p>
              {t("MyOrders.remainingAmount")}
              {minOrderDeliveryPrice > 0 && (
                <TooltipCom
                  text={`The store's minimum order fee is ${ParseFloat(
                    minOrderDeliveryPrice
                  )}.`}
                >
                  <i className="fa fa-info-circle" />
                </TooltipCom>
              )}
            </p>

            <p>{ParseFloat(remaining_amount || 0)}</p>
          </div>
        ) : null} */}
        {/* {card_fees > 0 && paymentOptionType == payment_type_card && (
          <div className="flex justify-between text-lg  font-normal text-[#676767]">
            <p>{t("Checkout.Card_Fees")}</p>
            <p>{ParseFloat(card_fees)}</p>
          </div>
        )} */}

        {paymentOptionType == payment_type_card && <></>}
        <hr className="my-2" />
        {platformFee > 0 &&
          <div className="flex justify-between ubermoveTextMedium textSm">
            <p>{t("CartDetails.platformFee")}</p>
            <p>{ParseFloat(platformFee || 0)}</p>
          </div>}
        {round_off != 0 && (
          <div className="flex justify-between ubermoveTextMedium textSm">
            <p>{t("CartDetails.round_total")}</p>
            <p>{ParseFloat(round_off || 0)}</p>
          </div>
        )}

        <div className="flex justify-between text-xl ubermoveTextMedium mb-4">
          <p>{t("CartDetails.total")}</p>
          <p>{ParseFloat((totalPrice) || 0)}</p>
        </div>
        <p className="text-[#7A7A7A] textMd font-normal">
          <img src="/images/exclamation-icon.svg" className="inline" />
          <span className="ml-2">
            {t("Checkout.allergies")}: {t("Checkout.allergiesMessage")}
          </span>
        </p>

        <div className="md:hidden block mt-2">
          {/* <Payment /> */}
          {/* <NewPayment /> */}
          <NewPaymentWithRazorpay />
        </div>
      </div>
      {/* variation .... */}
      {open && variationData && Object.keys(variationData).length > 0 && (
        <VariationModal
          menu_id={variationData?.menu_id}
          taxdata={variationData}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}
      {/* customized ..... */}
      {open && customizedData && Object.keys(customizedData).length > 0 && (
        <CustomizedModal
          menu_id={customizedData?.menu_id}
          taxdata={customizedData}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}

      {openPayment ? (
        <PaymentModal
          openPayment={openPayment}
          onClosePaymentModal={onClosePaymentModal}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CheckoutDetails;
